import React from 'react';
import moment from 'moment';
import { formatMomentDate } from 'utils/formatMomentDate';
import { useStoreSelector } from 'v3/data/store';
import { Content, FlexContainer } from 'v3/pages/SellersRanking/Header/PeriodAndGroupInfo/styles';
import { SubtitleMediumBold } from 'v3/shared/typography/SubtitleMedium';

export const PeriodAndGroupInfo = () => {
  const { filter } = useStoreSelector((store) => store.rankSeller);
  const startDate = filter.startDate ? moment(filter.startDate) : moment().startOf('month');
  const endDate = filter.finalDate ? moment(filter.finalDate) : moment();
  return (
    <Content>
      <FlexContainer>
        <SubtitleMediumBold>Período:</SubtitleMediumBold>
        {formatMomentDate(startDate)} - {formatMomentDate(endDate)}
      </FlexContainer>
    </Content>
  );
};
